<template>
  <b-container fluid>
    <!-- Cabeçalho da página -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h5>Gráficos Financeiros</h5>

      <!-- Botões de navegação de datas por ano em btn-group -->
      <div class="btn-group" role="group" aria-label="Navegação de Ano">
        <button type="button" class="btn btn-outline-secondary" @click="prevYear">
          Anterior
        </button>
        <button type="button" class="btn btn-outline-secondary disabled">
          {{ selectedYear }}
        </button>
        <button type="button" class="btn btn-outline-secondary" @click="nextYear">
          Próximo
        </button>
      </div>
    </div>

    <!-- primeira row: receitas a receber -->
    <div class="row mb-4">
      <div v-if="permiteGrafico('receitas-receber-mensal')" class="col-12 col-md-6 mb-4">
        <div class="chart-container">
          <ReceitasReceberChart endpoint="/gestao/graficos/individuais/receitas-receber-mensal"
            :data-inicio="dataInicio"
            :data-fim="dataFim"
            :redraw="true"
          />
        </div>
      </div>
      <div v-if="permiteGrafico('receitas-receber-tipo')" class="col-12 col-md-6 mb-4">
        <div class="chart-container">
          <ReceitasPorTipoPie endpoint="/gestao/graficos/individuais/receitas-receber-tipo"
            :data-inicio="dataInicio"
            :data-fim="dataFim"
          />
        </div>
      </div>
    </div> <!-- <-- fecha a primeira row aqui -->

    <!-- segunda row: receitas totais -->
    <div class="row mb-4">
      <div v-if="permiteGrafico('receitas-totais-mensal')" class="col-12 col-md-6 mb-4">
        <div class="chart-container">
          <TotaisReceitasChart
            :data-inicio="dataInicio"
            :data-fim="dataFim"
          />
        </div>
      </div>
      <div v-if="permiteGrafico('receitas-totais-anual')" class="col-12 col-md-6 mb-4">
        <div class="chart-container">
          <TotaisReceitasPie
            :data-inicio="dataInicio"
            :data-fim="dataFim"
          />
        </div>
      </div>
    </div>
    <p v-if="!(permiteGrafico('receitas-receber-mensal') || permiteGrafico('receitas-receber-tipo') || permiteGrafico('receitas-totais-mensal') || permiteGrafico('receitas-totais-anual'))" class="text-muted">Nenhum gráfico autorizado neste grupo.</p>
  </b-container>
</template>

<script>
import { relatoriosAccess } from '@/utils/relatoriosAccess'
import { BContainer } from 'bootstrap-vue-next'
import ReceitasReceberChart from '@/components/Dashboard/ReceitasReceberChart.vue'
import ReceitasPorTipoPie   from '@/components/Dashboard/ReceitasPorTipoPie.vue'
import TotaisReceitasChart  from '@/components/Gestao/Graficos/Financeiros/TotaisReceitasChart.vue'
import TotaisReceitasPie    from '@/components/Gestao/Graficos/Financeiros/TotaisReceitasPie.vue'

export default {
  name: 'FinanceirosView',
  components: {
    BContainer,
    ReceitasReceberChart,
    ReceitasPorTipoPie,
    TotaisReceitasChart,
    TotaisReceitasPie
  },
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      dataInicio: '',
      dataFim: ''
    }
  },
  created() {
    this.updatePeriod()
  },
  methods: {
    permiteGrafico(key) { return relatoriosAccess(this.$globalState).grafico(key) },
    updatePeriod() {
      this.dataInicio = `${this.selectedYear}-01-01`
      this.dataFim    = `${this.selectedYear}-12-31`
    },
    prevYear() {
      this.selectedYear--
      this.updatePeriod()
    },
    nextYear() {
      this.selectedYear++
      this.updatePeriod()
    }
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 250px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .chart-container {
    height: 300px;
  }
}

.btn-group .btn {
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
}
</style>
